<template>
  <el-container class="banner-config-wrapper">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList='searchList' ref='expSearch' :rightEventList="rightEventList"
        @rightFunc='rightFunc' v-on:getSearchObj='getSearchObj'></publicExpandSearch>
    </div>
    <el-main>
      <div class="main-content-list" style="overflow:auto;">
        <el-table :data="tableData" border style="width: 100%;" :header-cell-style="{
          background: '#FAFAFA',
          fontWeight: 'bold',
          color: '#333333',
          fontSize: '14px'
        }">
          <el-table-column prop="name" label="消息名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="eventName" label="事件名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="diseaseName" label="模板名称" align="center" class-name="nameClass">
            <template slot-scope="scope">
              <div class="merge-box">
                <div class="merge-box-item" v-for="(item, index) in scope.row.details" :key="index"
                  :title="item.templateName">
                  {{ item.templateName }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="shareImageUrl" label="推送渠道" align="center" class-name="nameClass">
            <template slot-scope="scope">
              <div class="merge-box">
                <div class="merge-box-item" v-for="(item, index) in scope.row.details" :key="index"
                  :title="item.channelName">
                  {{ item.channelName }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="发送状态" align="center" class-name="nameClass">
            <template slot-scope="scope">
              <div class="merge-box">
                <div class="merge-box-item" v-for="(item, index) in scope.row.details" :key="index" style="">
                  <span class="waitingSent" v-if="item.sendStatus == 1">待发送</span>
                  <span class="beSent" v-if="item.sendStatus == 2">发送中</span>
                  <span class="hasSent" v-if="item.sendStatus == 3">已发送</span>
                  <span class="cancelSend" v-if="item.sendStatus == 4">取消发送</span>
                  <!-- {{item.sendStatus}} -->
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="targetUsersType" label="目标用户" align="center">
            <template slot-scope="scope">
              <div v-show="scope.row.targetUsersType == 'set_patient_label'">标签集合-患者</div>
              <div v-show="scope.row.targetUsersType == 'set_user_doctor'">用户集合-医生</div>
              <div v-show="scope.row.targetUsersType == 'set_user_patient'">用户集合-患者</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="激活状态" align="center">
            <template slot-scope="scope">
              <div v-show="scope.row.status == 1"><span class="blue-icon">是</span></div>
              <div v-show="scope.row.status == 2"><span class="yellow-icon">否</span></div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
          <el-table-column prop="createUserName" label="创建人" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button :disabled="scope.row.status == 1" @click.native.prevent="editClick(scope.row, scope.$index)"
                type="text" size="small">
                编辑
              </el-button>
              <el-button v-if="scope.row.status == 1" @click.native.prevent="publishClick(scope.row, scope.$index)"
                type="text" size="small">
                <!-- {{ scope.row.status ? "停用" : "激活" }} -->
                停用
              </el-button>
              <el-button v-if="scope.row.status == 2" :disabled="scope.row.startStatus == 1"
                @click.native.prevent="publishClick(scope.row, scope.$index)" type="text" size="small">
                <!-- {{ scope.row.status ? "停用" : "激活" }} -->
                激活
              </el-button>
              <!-- <el-button @click.native.prevent="deleteClick(scope.row,scope.$index )" type="text" size="small">
                      删除
                    </el-button> -->
              <el-button @click.native.prevent="seeClick(scope.row, scope.$index)" type="text" size="small">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
        <el-pagination background :current-page="searchParams.current" :page-sizes="[10, 20, 30, 50]"
          :page-size="searchParams.size" layout="total, sizes, prev, pager, next, jumper" :total="total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {
  pageOperationalList,
  operationalDelete,
  operationalState,
  channelList
} from "@/api/operationalMessage";

export default {
  data() {
    return {
      breadList: [{ name: "运营管理" }, { name: "运营消息" }],
      rightEventList: [{ eventName: "新增运营消息", eventValue: 1 }],
      searchList: [
        {
          label: "消息名称",
          paramName: "name",
          inputType: "input"
        },
        {
          label: "目标用户",
          paramName: "targetUsersType",
          inputType: "select",
          optionData: [
            { label: "标签集合-患者", value: "set_patient_label" },
            { label: "用户集合-医生", value: "set_user_doctor" },
            { label: "用户集合-患者", value: "set_user_patient" }
          ]
        },
        {
          label: "推送渠道",
          paramName: "msgChannelId",
          inputType: "selectChannel",
          optionData: []
        },
        {
          label: "激活状态",
          paramName: "status",
          inputType: "select",
          optionData: [
            { label: "激活", value: 1 },
            { label: "停用", value: 2 }
          ]
        },
        {
          label: "日期",
          paramName: "updateTime",
          stringTime: "updateTime",
          inputType: "datetimerange",
          paramstartTime: "beginTime",
          paramEndTime: "endTime",
          isTime: true
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      loading: false,
      total: 0,
      platFormType: 1,
      userPlatForm: "platForm",

      showDialog: false,
      loading: false,
      total: 0, //总条数
      tableData: [],
      options: [],
      imgPath: process.env.VUE_APP_OSS_URL,
      edit: true,
      flag: false,
      VUE_APP_WECHATBASE_URL: "/api/dsicm-contact-platform/feign/file/upload",
      getMethodsList: [],
      bannerList: [{ name: "首页banner", value: "banner" }],
      // diseaseList: [],
      checkDisease: [],
      imgPath: process.env.VUE_APP_OSS_URL,
      timeList: [],
      resetFlag: true,
      editFlag: false, //是否编辑
      id: null,
      options: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      arr: [],
      getEndTime: 0,
      showAddQuestionShop: false, //添加用户集合弹窗
      showContentDialog: false,
      totalShop: 0,
      sendList: [], //数组
      showTemplateDialog: false, //模板是否展示
      mergeObj: {}, // 用来记录需要合并行的下标
      mergeArr: [
        "name",
        "title",
        "doctorTeamName",
        "diseaseName",
        "shareImageUrl",
        "createUserName",
        "updateUserName",
        "updateTime",
        "updateTime1",
        "updateTime2"
      ], // 表格中的列名
      listQueryShop: {
        //商品搜索条件
        //弹窗
        current: 1,
        size: 10,
        goodsName: null,
        beginOrderStartTime: null,
        endOrderStartTime: null
      },
      tableDataShop: [],
      sendStateObj: {},
      optionDataList: []
    };
  },
  created() {
    this.pageListrequest();
    this.channelListRequest();
  },
  mounted() {
    // this.getSpanArr(this.tableData);
  },
  filters: {
    //文字长度过滤
    ellipsis(value) {
      if (!value) {
        return;
      }
      if (value.length > 8) {
        return value.slice(0, 8) + "...";
      } else {
        return value;
      }
    }
  },
  methods: {
    pushTimeTypeObj(value) {
      let name = "";
      if (value == 1) {
        name = "未发送";
      } else if (value == 2) {
        name = "发送中";
      } else if (value == 3) {
        name = "发送完成";
      } else if (value == 4) {
        name = "取消发送";
      }
      return name;
    },
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.searchParams.msgChannelIds = null;
      if (
        this.searchParams.msgChannelId &&
        this.searchParams.msgChannelId.length > 0
      ) {
        // this.searchParams.msgChannelIds = this.searchParams.msgChannelId.toString();
        this.searchParams.msgChannelIds = this.searchParams.msgChannelId;
      }
      // delete this.searchParams.msgChannelId
      this.pageListrequest();
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.$router.push({
          path: "/termPage/operationalMessageAddEdit",
          query: {
            type: "add"
          }
        });
      }
    },
    pageListrequest() {
      pageOperationalList(this.searchParams).then(res => {
        if (res.code == 0) {
          if (res.data) {
            if (res.data.records && res.data.records.length > 0) {
              this.tableData = res.data.records.map((item, index) => {
                return {
                  ...item,
                  msgEventDescList: item.msgEventDesc
                    ? item.msgEventDesc.split("、")
                    : [],
                  msgEventNameList: item.msgEventName
                    ? item.msgEventName.split("、")
                    : []
                };
              });
              this.total = res.data.total;
              console.log(this.tableData, "this.tableData");
            } else {
              this.tableData = [];
              this.total = 0;
            }
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      });
    },
    editClick(item, index) {
      console.log(item, "item");
      this.$router.push({
        path: "/termPage/operationalMessageAddEdit",
        query: {
          type: "edit",
          id: item.id
        }
      });
    },
    publishClick(item, status) {
      //发布 || 下架
      if (item.status == 1) {
        // let flag = 1;
        // let confirmName = "确定要停用嘛？";
        // if (item.sendState == 1) {
        //   //停用 - 未开始发送
        //   confirmName = "消息尚未发送，停用后将暂停发送~";
        // } else if (item.sendState == 2) {
        //   //停用 - 发送进行中
        //   confirmName = "停用发送中的消息，将撤销发送任务，不可再次激活~";
        // }
        // this.$confirm("消息正在发送中，停用可能会中止继续发送~", "提示", {
        this.$confirm("[停用]之后的消息，将不可再次激活~", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        })
          .then(() => {
            operationalState({
              id: item.id,
              status: item.status == 1 ? 2 : 1
            }).then(res => {
              if (res.code == 0) {
                this.$message.success("停用成功");
                this.pageListrequest();
              }
            });
          })
          .catch(() => { });
      } else {
        this.$confirm("[激活]之后的消息，将会在预设的时间触发~", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        })
          .then(() => {
            operationalState({
              id: item.id,
              status: item.status == 1 ? 2 : 1
            }).then(res => {
              if (res.code == 0) {
                this.$message.success("激活成功");
                this.pageListrequest();
              }
            });
          })
          .catch(() => { });
      }

      // if (!status) {
      //   this.$confirm("消息正在发送中，停用可能会中止继续发送~", "提示", {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: "继续",
      //     cancelButtonText: "取消",
      //     customClass: "message-confirm-style"
      //   })
      //     .then(() => {
      //       operationalState({
      //         id: item.id,
      //         status: status == 1?0:1
      //       }).then(res => {
      //         if (res.code == 0) {
      //           if (status) {
      //             this.$message.success("停用成功");
      //           } else {
      //             this.$message.success("激活成功");
      //           }
      //           this.pageListrequest();
      //         }
      //       });
      //     })
      //     .catch(() => {});
      // } else {
      //   this.$confirm("消息正在发送中，停用可能会中止继续发送~", "确认信息", {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: "继续",
      //     cancelButtonText: "取消",
      //     customClass: "message-confirm-style"
      //   })
      //     .then(() => {
      //       operationalState({
      //         id: item.id,
      //         status: status == 1?0:1
      //       }).then(res => {
      //         if (res.code == 0) {
      //           if (status) {
      //             this.$message.success("停用成功");
      //           } else {
      //             this.$message.success("激活成功");
      //           }
      //           this.pageListrequest();
      //         }
      //       });
      //     })
      //     .catch(() => {});
      // }
    },

    //删除事件
    deleteClick(item, index) {
      this.$confirm("删除后，消息及发送记录将无法恢复~", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(() => {
        console.log(item, "item");
        operationalDelete({
          id: item.id
        })
          .then(res => {
            if (res.code == 0) {
              this.$message.success("删除成功");
            }
            if (this.total <= this.searchParams.size) {
              this.searchParams.current = 1;
            }
            this.pageListrequest();
          })
          .catch(() => { });
        // operationalDelete({
        //     id: item.id,
        //   }).then(res => {
        //     if (res.code == 0) {
        //       if (item.status) {
        //         this.$message.success("停用成功");
        //       } else {
        //         this.$message.success("激活成功");
        //       }
        //       this.pageListrequest();
        //     }
        //   });
        console.log(item, "sssss");
      });
    },
    resetClickShop() {
      //弹窗集合服务重置
      this.listQueryShop.size = 10;
      this.listQueryShop.current = 1;
      this.listQueryShop.goodsName = null;
      this.shopPageRequest();
    },
    searchClickShop() {
      //弹窗集合服务搜索
      this.listQueryShop.size = 10;
      this.listQueryShop.current = 1;
      this.shopPageRequest();
    },
    handleSizeChange(val) {
      //列表分页
      this.searchParams.size = val;
      this.searchParams.current = 1;
      this.pageListrequest();
    },
    handleCurrentChange(val) {
      //列表分页
      this.searchParams.current = val;
      this.pageListrequest();
    },
    shopPageRequest() { },
    handleCloseShop() {
      //添加集合弹窗关闭
      this.showAddQuestionShop = false;
      this.showContentDialog = true;
    },
    handleClose() {
      //运营消息弹窗关闭
      this.showContentDialog = false;
    },
    choseListData() {
      //更改模板按钮
      this.showTemplateDialog = true;
    },
    seeClick(item, index) {
      this.$router.push({
        path: "/termPage/operationalMessageAddEdit",
        query: {
          type: "see",
          id: item.id
        }
      });
    },
    changeOrderTime() {
      //订单查询时间
      let timeBegin = this.createOrderTimeArr[0].toString().substring(0, 10);
      let timeEnd = this.createOrderTimeArr[1].toString().substring(0, 10);
      this.listQueryShop.beginOrderStartTime = Number(timeBegin) * 1000;
      this.listQueryShop.endOrderStartTime = Number(timeEnd) * 1000;
    },
    cancelSubmit() {
      this.showContentDialog = false;
    },
    confirmSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
        } else {
          return false;
        }
      });
    },
    scopeApplicationChange(value) { },
    scopeTimeChange(value) { },
    addIndexValueQuantitativemClick() {
      this.showContentDialog = false;
      this.showAddQuestionShop = true;
    },
    assessmentSendTemplate() {
      //选用模板
      this.showTemplateDialog = false;
    },
    sendChange() { },
    channelListRequest() {
      channelList().then(res => {
        if (res.code == 0) {
          if (res.data) {
            this.searchList[2].optionData = res.data.map((item, index) => {
              return {
                ...item,
                label: item.msgChannelName,
                value: item.id
              };
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "./operationalMessage.less";
</style>
<style lang="less">
.popconfirmbox .el-popconfirm__main {
  align-items: flex-start !important;
  line-break: anywhere !important;
  margin: 0 0 10px 0 !important;
  letter-spacing: -1px;
}

.popconfirmbox .el-popconfirm__main .el-popconfirm__icon {
  margin-top: 3px;
}
</style>
